#import "./shiftInfo.gql"

mutation CreateShift(
  $id: ID!
  $name: String
  $startTime: String
  $endTime: String
  $monday: Boolean!
  $tuesday: Boolean!
  $wednesday: Boolean!
  $thursday: Boolean!
  $friday: Boolean!
  $saturday: Boolean!
  $sunday: Boolean!
) {
  createShift(
    id: $id
    name: $name
    startTime: $startTime
    endTime: $endTime
    monday: $monday
    tuesday: $tuesday
    wednesday: $wednesday
    thursday: $thursday
    friday: $friday
    saturday: $saturday
    sunday: $sunday
  ) {
    shift {
      ...shiftInfo
    }
  }
}

mutation UpdateShift(
  $id: ID!
  $name: String!
  $startTime: String!
  $endTime: String!
  $monday: Boolean!
  $tuesday: Boolean!
  $wednesday: Boolean!
  $thursday: Boolean!
  $friday: Boolean!
  $saturday: Boolean!
  $sunday: Boolean!
) {
  updateShift(
    id: $id
    name: $name
    startTime: $startTime
    endTime: $endTime
    monday: $monday
    tuesday: $tuesday
    wednesday: $wednesday
    thursday: $thursday
    friday: $friday
    saturday: $saturday
    sunday: $sunday
  ) {
    shift {
      ...shiftInfo
    }
  }
}

query GetAllShifts {
  shifts {
    ...shiftInfo
  }
}

mutation DeleteShift($id: ID!) {
  deleteShift(id: $id) {
    name
  }
}
